<template>
  <div class="header-box">
    <el-header class="clearfix">
      <div class="heder-f fl" style="user-select: none;">
        <img :src="logoSrc" alt="" class="login" id="logo" />
        <h2>&nbsp;|&nbsp;{{CustomForm.systemName}}</h2>
      </div>
      <el-dropdown class="heder-r fr">
        <span class="logTea"><img src="../assets/img/tea.png" alt="" />
          <em>{{ userInfo.realName }}</em>
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdown-show" v-show="false">
          <el-dropdown-item @click.native="handleEditPsd">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="outLogin">安全退出</el-dropdown-item>
        </el-dropdown-menu>
        <el-dropdown-menu></el-dropdown-menu>
      </el-dropdown>
    </el-header>


    <el-dialog 
      :visible.sync="psdDialog" 
      :title="isPassWordExpired == 1 ? '修改密码（您的密码已到期，请修改密码）': '修改密码'" 
      :close-on-press-escape="false"
      :show-close="isPassWordExpired == 1 ? false: true"
      :close-on-click-modal="false"
      width="360px"
    >
      <!-- <template v-slot:content> -->
        <slot name="content" class="content">
          <div class="HeaderDialogMain">
            <el-form :model="psdRuleForm" :rules="rules" ref="psdRuleForm" class="editPsdForm" status-icon>
              <el-form-item label="新密码" prop="password" style="margin-bottom: 48px;">
                <el-input
                  v-model="psdRuleForm.password"
                  type="password"
                  autocomplete="new-password"
                ></el-input>

                <ots-password-tooltip></ots-password-tooltip>


              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  v-model="psdRuleForm.confirmPassword"
                  type="password"
                  autocomplete="new-password"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </slot>
      <template v-slot:footer>
        <el-button round @click="psdDialog = false" v-if="isPassWordExpired !== 1">取消</el-button>
        <el-button type="primary" round @click="rightEditPsd('psdRuleForm')">确定</el-button>
      </template>
    </el-dialog>



  </div>
</template>

<script>
import { checkPwd, passWordStrength } from "@/common/verify.js";


import logoSet from "@/http/logoSet.js";
import { logoDefault } from "@/http/logoSet.js";
export default {
  name: "out-header",
  data() {
    return {
      userInfo: {},
      psdDialog: false,
      isPassWordExpired: 0,
      psdRuleForm: {
        // oldPsd:'',
        userId: "",
        password: "",
        confirmPassword: "",
        tenant: "",
      },

      CustomForm: {
        systemName: "弘成慧考平台"
      },

      rules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
      logoSrc: "",
    };
  },
  watch: {
    "psdDialog": function(value) {
      if (this.isPassWordExpired == 1 && value == false) {
        this.pasDialog = true;
      }
    },

  },
  created() {
    this.getCustomSet()
  },
  mounted() {
    this.$store.commit("setUserInfo", JSON.parse(localStorage.getItem("userInfo")));
    this.userInfo = this.$store.state.userInfo;
    // 密码到期：是否强制修改密码
    this.isMustEditPsd();
  },
  methods: {
    // 密码到期：是否强制修改密码
    isMustEditPsd() {
      this.isPassWordExpired = JSON.parse(localStorage.getItem("userInfo")).isPassWordExpired;
      if (this.isPassWordExpired === 1) {
        this.psdDialog = true;
      }
    },

    /***************************************
     * @getCustomSet 配置个性化LOGO,系统名
     ***************************************/
    getCustomSet(){
      let tenant = window.localStorage.getItem('tenant')
      let defaultLogo = require('@/assets/img/customDefault.png')
      this.$api.system.getSystemNameFN({tenant}).then(({data})=>{
        this.CustomForm.systemName = data.systemName ? data.systemName : '弘成慧考平台'
        this.logoSrc = data.isUsedLogo == 1 ? data.logoUrl ? data.logoUrl : defaultLogo : defaultLogo
      })
    },

    /***************************************
     * @getLogo 系统设置LOGO (已弃用)
     ***************************************/
    getLogo() {
      const tenant = window.localStorage.getItem("tenant");
      logoSet("admin", tenant)
        .then(({ code, data }) => {
          if (code == 1) {
            this.logoSrc = data;
          } else {
            this.logoSrc = logoDefault("admin")
          }
        }).catch(() => {
          this.logoSrc = logoDefault("admin")
        })
    },

    
    handleEditPsd() {
      this.psdDialog = true;
      this.psdRuleForm.password = "";
      this.psdRuleForm.confirmPassword = "";
    },
    rightEditPsd(psdRuleForm) {
      this.$refs[psdRuleForm].validate((valid) => {
        if (valid) {
          let editPsdQuery = {
            userId: this.userInfo.id,
            password: this.psdRuleForm.password,
            confirmPassword: this.psdRuleForm.confirmPassword,
            tenant: window.localStorage.getItem("tenant"),
          };
          this.$api.login.editPsd(editPsdQuery).then((res) => {
            if (res.code) {
              let userInfo = JSON.parse(localStorage.getItem("userInfo"));
              userInfo.isPassWordExpired = 0;
              this.isPassWordExpired = 0;
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              this.psdDialog = false;
              this.$message.success("密码修改成功！");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.psdRuleForm.password !== this.psdRuleForm.confirmPassword) {
          callback(new Error("确认密码必须和新密码相同"));
        } else {
          callback();
        }
      }
      callback();
    },
    outLogin() {
      this.mixin_outLogin();
    },
  },
};
</script>

<style scoped lang="less">
.header-box {
  width: 100%;
}
.el-header {
  padding: 0 10px 0 18px;
  height: 60px;
  line-height: 60px;
  background: @c-006;
  box-shadow: 0px 4px 12px 0px rgba(0, 53, 128, 0.3);
  .heder-f {
    width: auto;
    h2 {
      color: #FFF;
      float: right;
      font-size: 18px;
    }
    height: 60px;
    text-align: left;
    color: #fff;
    .login {
      height: 42px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .heder-r {
    margin-right: 30px;
    position: relative;
    .logTea {
      cursor: pointer;
      display: flex;
      justify-content: right;
      align-items: center;
      height: 60px;
      color: #fff;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 5px;
        text-align: right;
      }
      em {
        font-style: normal;
        color: #fff;
        max-width: 113px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
// .dropdown-show {
//   width: 150px!important;
// }

.title-msg {
  font-size: 16px;
  font-weight: 600;
  color: #15151a;
  position: relative;
  margin-top: 20px;
}
.title-msg:after {
  content: " ";
  position: absolute;
  left: -8px;
  top: 5px;
  width: 3px;
  height: 14px;
  background-color: #3388ff;
}
/deep/ .el-input__inner {
  width: 280px;
  height: 40px;
}
/deep/ .el-form-item__error {
  line-height: 16px;
}
.title-msg-top {
  margin-top: 0 !important;
  margin-bottom: 10px !important;
}
.textareaBox {
  width: 100% !important;
}
/deep/ .el-form-item {
  display: inline-block;
}
/deep/ .el-form-item__label {
  float: none;
}
/deep/ .el-form-item__content {
  margin-left: 0 !important;
  // margin-right: 50px;
}

.HeaderDialogMain {
  display: flex;
  .descript {
    padding-top: 18px;
    line-height: 24px;
  }
}
.editPsdForm {
  width: 300px;
}
.editPsdForm /deep/ .el-input {
  width: 280px;
}
.editPsdForm /deep/ .el-input__inner {
  width: 280px;
}
.pubMsg {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.colorBtn {
  font-size: 16px;
  color: #fff;
}
.dialog-footer /deep/ .el-button--default:hover {
  background: #ecf5ff;
  color: #176de6;
  border-color: #176de6 !important;
}
/deep/ .el-dialog{
  border-radius: 8px;
}
/deep/ .el-dialog__title {
  font-weight: 700;
}
/deep/ .el-dialog__body {
  padding: 32px;
}
/deep/ .el-dialog.auto-scroll .el-dialog__footer {
  padding-top: 0;
}
/deep/ .el-dialog .el-input {
  // width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-input__inner,
/deep/ .el-dialog .el-input__icon {
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-form-item__content {
  line-height: 1;
}
/deep/ .el-dialog .default-upload-container {
  width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-form-item__label {
  line-height: 1;
  padding-bottom: 16px;
}

/deep/ .el-dialog .el-pagination__sizes .el-input {
  width: 100px;
}
/deep/ .el-dialog .el-pagination__editor.el-input {
  width: 50px;
}
/deep/ .el-dialog .el-pagination__sizes .el-input__inner,
/deep/ .el-dialog .el-pagination__sizes .el-input__icon,
/deep/ .el-dialog .el-pagination__jump .el-input__inner {
  height: 28px;
  line-height: 28px;
}
/deep/ .el-radio-button__inner {
  margin-right: 16px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.dialog-footer /deep/ .el-button {
  width: auto;
  height: 30px;
  // line-height: 30px;
  border-radius: 15px;
  padding: 0 23px;
  box-sizing: border-box;
}
/deep/ .el-form-item__label {
  float: none !important;
  display: block;
  text-align: left;
  padding-bottom: 8px !important;
}
/deep/ .el-dialog.is-fullscreen {
  background: #f4f5f8;
  margin-top: 60px;
  margin-bottom: 0;
  height: calc(100% - 60px);
  .el-dialog__header {
    background: #fff;
    height: 64px;
    box-sizing: border-box;
    box-shadow: 0px -1px 0px 0px #f1f2f5;
    border-radius: 8 px 8 px 0 px 0 px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .el-dialog__headerbtn{
      top: 23px;
    }
  }
}
/deep/ .el-dialog.is-fullscreen .el-dialog__body {
  padding-top: 0 !important;
}
</style>
